"use client";
import { jsxs as s, jsx as a } from "react/jsx-runtime";
import c from "next/image";
import { memo as n } from "react";
import { Box as r } from "../../base/Base.js";
import '../../../assets/PlateAdvantage.css';const l = "_plate_1acry_1", i = "_content_1acry_10", p = "_image_1acry_15", t = {
  plate: l,
  content: i,
  image: p
}, _ = n(
  ({ image: e, children: o, ...m }) => /* @__PURE__ */ s("div", { className: t.plate, ...m, children: [
    /* @__PURE__ */ a(r, { className: t.content, children: o }),
    /* @__PURE__ */ a(c, { src: e, alt: "", className: t.image })
  ] })
);
_.displayName = "PlateAdvantage";
export {
  _ as PlateAdvantage
};
